// used by code_block-{json,xml} partials

import { Controller } from "@hotwired/stimulus"
window.Prism = window.Prism || {};
window.Prism.manual = true; // disable prism automatic highlighting https://prismjs.com/docs/prism#.manual
import Prism from "prismjs"
import "prismjs/components/prism-json"


export default class extends Controller {
  static values = {
    language: { type: String, default: 'json' },
  }

  connect () {
    this.highlight(this.element);
  }

  highlight (codeEl) {
    codeEl.classList.add(`language-${this.languageValue}`)
    Prism.highlightElement(codeEl)
  }
}
